import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useCreateCustomThemeWithNameModal } from "./CreateCustomThemeWithNameModal";

export const UnsavedCustomThemeDropdown = () => {
  const { show: showCreateCustomThemeWithNameModal } =
    useCreateCustomThemeWithNameModal();
  const { currentCanvasTheme, toggleCurrentCanvasTheme, appearance } =
    useBuilderStore(state => ({
      currentCanvasTheme: state.currentCanvasTheme,
      toggleCurrentCanvasTheme: state.toggleCurrentCanvasTheme,
      appearance: state.appearance,
    }));
  const { reset } = useFormContext();

  return (
    <Dropdown
      size="medium"
      button={
        <IconButton
          name="16-menu-dots-horizontal"
          iconSize={16}
          buttonSize={20}
          ariaLabel={t(
            "settings.site.pages.actions.unsaved_custom_theme_actions.aria_label",
          )}
        />
      }
    >
      <Dropdown.ItemWithLink
        onClick={() =>
          showCreateCustomThemeWithNameModal({
            currentCanvasTheme,
            toggleCurrentCanvasTheme,
            appearance,
            reset,
          })
        }
      >
        {t(
          "settings.site.pages.actions.unsaved_custom_theme_actions.actions.save_as_custom_theme",
        )}
      </Dropdown.ItemWithLink>
    </Dropdown>
  );
};
